import { render, staticRenderFns } from "./radio-primary.vue?vue&type=template&id=599f2fe0&scoped=true&"
import script from "./radio-primary.vue?vue&type=script&lang=js&"
export * from "./radio-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f2fe0",
  null
  
)

export default component.exports